import GoogleAdsSettings from '@/modules/integrations/types/googleads/GoogleAdsSettings'
import GoogleAdsOverview from '@/modules/integrations/types/googleads/GoogleAdsOverview'
import GoogleAdsSyncDialog from '@/modules/integrations/types/googleads/GoogleAdsSyncDialog'
import GoogleAdsReauthenticateDialog from '@/modules/integrations/types/googleads/GoogleAdsReauthenticateDialog'

export default Object.freeze({
  type: 'googleads',
  title: 'Integrations_GoogleAds',
  category: 'Integrations_Advertising_Category',
  description: 'Integrations_GoogleAds_Description',
  image: require('@/img/integrations/googleads.png'),
  requiresAdmin: false,
  connectUrl: function(domain, projectId, integrationId = null) {
    if (integrationId) {
      return `${domain}/integration/google-ads/redirect?project_id=${projectId}&integration_id=${integrationId}`
    }

    return `${domain}/integration/google-ads/redirect?project_id=${projectId}`
  },
  components: {
    settings: GoogleAdsSettings,
    overview: GoogleAdsOverview
  },
  actions: [
    {
      icon: 'el-icon-refresh-right',
      label: 'Integrations_GoogleAds_Action_Reauthenticate',
      dialog: GoogleAdsReauthenticateDialog
    },
    {
      icon: 'el-icon-refresh',
      label: 'Integrations_GoogleAds_Action_Sync',
      dialog: GoogleAdsSyncDialog
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/ad-retargeting'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/googleads/index.js